<template>
  <v-chip
    text-color="grey darken-1"
    class="font-weight-bold caption"
    v-bind="$attrs"
  >
    <v-avatar left>
      <v-img :src="imagePath">
        <template v-slot:placeholder>
          <v-icon
            small
            color="grey darken-1"
          >
            directions_boat
          </v-icon>
        </template>
      </v-img>
    </v-avatar>
    {{ name }}
  </v-chip>
</template>
<script>
  export default {
    name: 'YachtChip',
    props: {
      name: {
        type: String,
        required: true
      },
      imagePath: {
        default: '',
        type: String
      }
    }
  }
</script>
